import script from "./BotVersionTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./BotVersionTag.vue?vue&type=script&setup=true&lang=ts"

import "./BotVersionTag.vue?vue&type=style&index=0&id=370884b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370884b1"]])

export default __exports__